import {inject, Injectable} from '@angular/core';
import {Observable, share, tap, throwError} from "rxjs";
import {Pbx} from "../models/pbx";
import {CallEvent} from "../../units/models/call-event";
import {UnitCallEventsFilters} from "../../units/models/unit-call-events-filters";
import {PbxMode} from "../models/pbx_mode";
import {PbxManager} from "./pbx-manager";
import {CallApiService} from "../../shared/services/call-api.service";

@Injectable()
export class ApiPbxManagerService extends PbxManager {

    private callApi = inject(CallApiService);
    _pbxDashboardRetrieval$: Observable<any> | null = null;

    constructor() { super(); }

    override getPbxs(): Observable<Pbx[]> {
        return this.get<Pbx[]>("/pbxs");
    }

    override getPbxDashboard(installation_id: string, pbx_id: string): Observable<Pbx> {
        if (!installation_id) {
            return throwError(() => new Error("Invalid installation id"));
        }

        if (!pbx_id) {
            return throwError(() => new Error("Invalid pbx id"));
        }

        if (!this._pbxDashboardRetrieval$) {
            this._pbxDashboardRetrieval$ = this.get<Pbx>(
                `/installations/${installation_id}/pbxs/${pbx_id}/dashboard`
            ).pipe(
                share(),
                tap(() => (this._pbxDashboardRetrieval$ = null))
            );
        }

        return this._pbxDashboardRetrieval$;
    }

    override getPbxCallEvents(installation_id: string, pbx_id: string, pagination?: any, filters?: UnitCallEventsFilters): Observable<CallEvent[]> {
        if (!installation_id) {
            return throwError(() => new Error("Invalid installation id"));
        }

        if (!pbx_id) {
            return throwError(() => new Error("Invalid pbx id"));
        }

        const queryParams = new URLSearchParams();

        if (pagination?.index !== undefined && pagination.index !== null) {
            queryParams.set('page_index', pagination.index.toString());
        }
        if (pagination?.size !== undefined && pagination.size !== null) {
            queryParams.set('page_size', pagination.size.toString());
        }

        if (filters?.DeviceId) {
            queryParams.set('doorstation_id', filters.DeviceId);
        }
        if (filters?.Status !== undefined && filters.Status !== null) {
            queryParams.set('state', filters.Status.toString());
        }
        if (filters?.Date) {
            const date = new Date(filters.Date);
            const startOfDay = new Date(date);
            startOfDay.setHours(0, 0, 0, 0);
            const startTime = Math.floor(startOfDay.getTime() / 1000);
            const endOfDay = new Date(date);
            endOfDay.setHours(23, 59, 59, 999);
            const endTime = Math.floor(endOfDay.getTime() / 1000);
            queryParams.set('start', startTime.toString());
            queryParams.set('end', endTime.toString());
        }

        const baseUrl = `/installations/${installation_id}/pbxs/${pbx_id}/calls`;
        const queryString = queryParams.toString();
        const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

        return this.callApi.get<CallEvent[]>(url).pipe(share());
    }

    changePbxMode(installation_id: string, pbx_id: string, mode: PbxMode): Observable<Pbx> {
        const url = `/installations/${installation_id}/pbxs/${pbx_id}/mode`;
        return this.post<Pbx>(url, {mode}).pipe(share());
    }

}
